import ApiClient from "./ApiClient";
import PagedResult from "../models/shared/PagedResult";
import PaymentRequest from "../models/payment-request/PaymentRequest";
import PaymentRequestList from "../models/payment-request/PaymentRequestList";
import PaymentRequestStudent from "../models/payment-request/PaymentRequestStudent";
import StudentNumberOfDays from "../models/payment-request/StudentNumberOfDays";
import StudentCostData from "../models/payment-request/StudentCostData";
import PaymentRequestSchoolCarrierCost from "../models/payment-request/PaymentRequestSchoolCarrierCost";
import PaymentRequestAuthorizedCarrierCost from "../models/payment-request/PaymentRequestAuthorizedCarrierCost";
import PaymentRequestDetails from "../models/payment-request/PaymentRequestDetails";
import PaymentRequestFilter from "../models/payment-request/PaymentRequestFilter";
import PaymentRequestFilterValue from "../models/payment-request/PaymentRequestFilterValue";
import PaymentRequestSchoolCarrier from "../models/payment-request/PaymentRequestSchoolCarrier";
import PaymentRequestAuthorizedCarrier from "../models/payment-request/PaymentRequestAuthorizedCarrier";
import FinancingRequestStudentDataInfo from "../models/financing-request/FinancingRequestStudentDataInfo";
import AnnualAdministration from "../models/admin/annual-administration/AnnualAdministration";
import NewPaymentRequestData from "../models/payment-request/NewPaymentRequestData";

export default class PaymentRequestApiClient {
  apiClient: ApiClient;
  urlPrefix: string = "payment-requests/";

  constructor() {
    this.apiClient = new ApiClient();
  }

  // async getStudentsForNewPaymentRequests(schoolTypeId: number, month: Date) {
  //   const requests = await this.apiClient.get(
  //     this.urlPrefix + `new/students?schoolTypeId=${schoolTypeId}&date=${month}`
  //   );

  //   return requests as Array<PaymentRequestStudent>;
  // }

  // async getSchoolCarriersForNewPaymentRequests(
  //   schoolYearId: number,
  //   month: Date
  // ) {
  //   const schoolCarriers = await this.apiClient.get(
  //     this.urlPrefix +
  //       `new/school-carriers?schoolYearId=${schoolYearId}&date=${month}`
  //   );

  //   return schoolCarriers as Array<PaymentRequestSchoolCarrier>;
  // }

  // async getAuthorizedCarriersForNewPaymentRequests(
  //   schoolYearId: number,
  //   month: Date
  // ) {
  //   const authorizedCarriers = await this.apiClient.get(
  //     this.urlPrefix +
  //       `new/authorized-carriers?schoolYearId=${schoolYearId}&date=${month}`
  //   );

  //   return authorizedCarriers as Array<PaymentRequestAuthorizedCarrier>;
  // }

  async getAllPaymentRequestData(
    schoolTypeId: number,
    schoolYearId: number,
    month: Date | string
  ) {
    const date = month instanceof Date ? month : new Date(month);
    const formattedDate = toLocalISOString(date);

    const data = await this.apiClient.get(
      `${this.urlPrefix}new/all-payment-request-data?schoolTypeId=${schoolTypeId}&schoolYearId=${schoolYearId}&date=${formattedDate}`
    );
    return data as NewPaymentRequestData;
  }
  

  async getStudentsCostDataForNewPaymentRequest(
    schoolYearId: number,
    studentsNumberOfDays: StudentNumberOfDays[],
    date: Date
  ) {
    const costData = await this.apiClient.post(
      this.urlPrefix + "new/students-cost-data",
      {
        SchoolYearId: schoolYearId,
        StudentNumberOfDays: studentsNumberOfDays,
        Date: date
      }
    );

    return <StudentCostData[]>costData;
  }

  async calculateSchoolCarrierCost(
    schoolYearId: number,
    schoolCarrierId: number,
    numberOfDays: number
  ) {
    const schoolCarrierCost = await this.apiClient.get(
      `${this.urlPrefix}costs/school-carrier?schoolYearId=${schoolYearId}&schoolCarrierId=${schoolCarrierId}&numberOfDays=${numberOfDays}`
    );

    return <PaymentRequestSchoolCarrierCost>schoolCarrierCost;
  }

  async calculateAuthorizedCarrierCost(
    schoolYearId: number,
    authorizedCarrierId: number,
    numberOfDays: number
  ) {
    const authorizedCarrierCost = await this.apiClient.get(
      `${this.urlPrefix}costs/authorized-carrier?schoolYearId=${schoolYearId}&authorizedCarrierId=${authorizedCarrierId}&numberOfDays=${numberOfDays}`
    );

    return <PaymentRequestAuthorizedCarrierCost>authorizedCarrierCost;
  }

  async getDetails(id: string) {
    const details = await this.apiClient.get(`${this.urlPrefix}${id}/details`);

    return details as PaymentRequestDetails;
  }

  async exportDetails(paymentRequestId: string) {
    await this.apiClient.download(
      this.urlPrefix + `${paymentRequestId}/details/export`
    );
  }

  async getPaymentRequestForEdit(id: number) {
    const paymentRequest = await this.apiClient.get(
      this.urlPrefix + `${id}/edit`
    );
    return <PaymentRequest>paymentRequest;
  }

  async getFinancingRequestStudentDataInfoByDate(
    schoolYearId: number,
    month: Date
  ) {
    const requests = await this.apiClient.get(
      this.urlPrefix +
        `student-data-info/by-date?schoolYearId=${schoolYearId}&date=${month}`
    );

    return requests as Array<FinancingRequestStudentDataInfo>;
  }

  async getFinancingRequestStudentDataInfoById(paymentRequestId: number) {
    const requests = await this.apiClient.get(
      this.urlPrefix +
        `student-data-info/by-id?paymentRequestId=${paymentRequestId}`
    );

    return requests as Array<FinancingRequestStudentDataInfo>;
  }

  async createPaymentRequest(paymentRequest: PaymentRequest) {
    await this.apiClient.post(this.urlPrefix, paymentRequest);
  }

  async createPaymentRequestDraft(paymentRequest: PaymentRequest) {
    const paymentRequestId = await this.apiClient.post(
      this.urlPrefix + "draft",
      paymentRequest
    );

    return paymentRequestId as number;
  }

  async updatePaymentRequestDraft(paymentRequest: PaymentRequest) {
    await this.apiClient.put(this.urlPrefix + "draft", paymentRequest);
  }

  async finishPaymentRequest(paymentRequest: PaymentRequest) {
    await this.apiClient.put(this.urlPrefix, paymentRequest);
  }

  async getSearchFilters() {
    const filters = await this.apiClient.get(`${this.urlPrefix}search/filters`);

    return filters as PaymentRequestFilter;
  }

  async search(
    filter: PaymentRequestFilterValue,
    page?: number,
    pageItems?: number
  ) {
    const requests = await this.apiClient.get(
      `${this.urlPrefix}search?page=${page}` +
        `&pageSize=${pageItems}` +
        `&schoolYearId=${filter.schoolYearId}` +
        `&date=${filter.date}`
    );

    return requests as PagedResult<PaymentRequestList>;
  }

  async deletePaymentRequest(id: number) {
    const paymentRequest = await this.apiClient.delete(
      this.urlPrefix + `${id}`
    );
  }

  async getCanAddNewRequest() {
    const respons = await this.apiClient.get(this.urlPrefix + `isNewEnabled`);

    return respons as boolean;
  }

  async getAnualPricing() {
    const respons = await this.apiClient.get(this.urlPrefix + `anualPricing`);

    return respons as AnnualAdministration[];
  }

}

function toLocalISOString(date: Date): string {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  const milliseconds = date.getMilliseconds().toString().padStart(3, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
}